<template>
  <div v-if="loading" class="loading">
    <van-loading size="32px" type="circular" color="#846ffe" vertical
      >加载中...</van-loading
    >
  </div>
  <div v-else class="recipe-detail">
    <div
      class="week-rate"
      :style="{
        backgroundColor:
          active % 4 === 0
            ? '#F4F3FE'
            : active % 4 === 1
            ? '#FFFAE8'
            : active % 4 === 2
            ? '#F6FEE4'
            : '#FFF4F6'
      }"
    >
      <div class="week-rate-level">
        <div class="left">
          <img v-if="active % 4 === 0" src="@/assets/home/stars.svg" />
          <img v-else-if="active % 4 === 1" src="@/assets/home/star1.svg" />
          <img v-else-if="active % 4 === 2" src="@/assets/home/star2.svg" />
          <img v-else-if="active % 4 === 3" src="@/assets/home/star3.svg" />
          <div
            class="week-rate-title"
            :style="{
              color:
                active % 4 === 0
                  ? '#6D56EF'
                  : active % 4 === 1
                  ? '#987926'
                  : active % 4 === 2
                  ? '#538321'
                  : '#C5302D'
            }"
          >
            本周营养评级
          </div>
        </div>
        <div class="right" v-if="active % 4 === 0">
          <img v-if="score >= 90" src="@/assets/home/Purple_s.svg" />
          <img
            v-else-if="score < 90 && score >= 80"
            src="@/assets/home/Purple_a.svg"
          />
          <img
            v-else-if="score < 80 && score >= 70"
            src="@/assets/home/Purple_b.svg"
          />
          <img
            v-else-if="score < 70 && score >= 60"
            src="@/assets/home/Purple_c.svg"
          />
          <img
            v-else-if="score < 60 && score >= 0"
            src="@/assets/home/Purple_d.svg"
          />
          <img v-else src="" />
        </div>
        <div class="right" v-else-if="active % 4 === 1">
          <img v-if="score >= 90" src="@/assets/home/yellow_s.svg" />
          <img
            v-else-if="score < 90 && score >= 80"
            src="@/assets/home/yellow_a.svg"
          />
          <img
            v-else-if="score < 80 && score >= 70"
            src="@/assets/home/yellow_b.svg"
          />
          <img
            v-else-if="score < 70 && score >= 60"
            src="@/assets/home/yellow_c.svg"
          />
          <img
            v-else-if="score < 60 && score >= 0"
            src="@/assets/home/yellow_d.svg"
          />
          <img v-else src="" />
        </div>
        <div class="right" v-else-if="active % 4 === 2">
          <img v-if="score >= 90" src="@/assets/home/green_s.svg" />
          <img
            v-else-if="score < 90 && score >= 80"
            src="@/assets/home/green_a.svg"
          />
          <img
            v-else-if="score < 80 && score >= 70"
            src="@/assets/home/green_b.svg"
          />
          <img
            v-else-if="score < 70 && score >= 60"
            src="@/assets/home/green_c.svg"
          />
          <img
            v-else-if="score < 60 && score >= 0"
            src="@/assets/home/green_d.svg"
          />
          <img v-else src="" />
        </div>
        <div class="right" v-else-if="active % 4 === 3">
          <img v-if="score >= 90" src="@/assets/home/pink_s.svg" />
          <img
            v-else-if="score < 90 && score >= 80"
            src="@/assets/home/pink_a.svg"
          />
          <img
            v-else-if="score < 80 && score >= 70"
            src="@/assets/home/pink_b.svg"
          />
          <img
            v-else-if="score < 70 && score >= 60"
            src="@/assets/home/pink_c.svg"
          />
          <img
            v-else-if="score < 60 && score >= 0"
            src="@/assets/home/pink_d.svg"
          />
          <img v-else src="" />
        </div>
      </div>
      <div class="week-rate-item">
        <div class="title" @click="toNutrition">
					<div>能量分布</div>
					<div class="more">更多</div>
				</div>
        <div class="circle" v-if="proList.length > 0">
          <div class="pr" v-for="(item, index) in proList" :key="index">
            <van-circle
              :id="item.id"
              v-model="item.result.split('%')[0]"
              :color="
                item.text === '不足'
                  ? '#FD6C3B'
                  : item.text === '适量'
                  ? '#31CA8A'
                  : '#FFA900'
              "
              layer-color="#ededed"
              :rate="100"
              stroke-width="100"
            />
            <div class="name">{{ item.name }}</div>
            <div class="data">
              <p class="rate">{{ item.result }}</p>
              <p v-if="item.text === '不足'" class="level poor">不足</p>
              <p v-else-if="item.text === '适量'" class="level good">适量</p>
              <p v-else class="level normal">过量</p>
            </div>
          </div>
        </div>
      </div>
      <img
        v-if="active % 4 === 0"
        class="week-help"
        src="@/assets/home/purple.svg"
        @click="$emit('showHelp')"
      />
      <img
        v-else-if="active % 4 === 1"
        class="week-help"
        src="@/assets/home/yellow.svg"
        @click="$emit('showHelp')"
      />
      <img
        v-else-if="active % 4 === 2"
        class="week-help"
        src="@/assets/home/green.svg"
        @click="$emit('showHelp')"
      />
      <img
        v-else-if="active % 4 === 3"
        class="week-help"
        src="@/assets/home/pink.svg"
        @click="$emit('showHelp')"
      />
    </div>
    <day-recipe
      v-if="!loading"
      :current-recipe="currentRecipe"
      :current-week="currentWeek"
      @update-week="update"
    >
    </day-recipe>
    <!-- <div class="position-container"></div> -->
  </div>
</template>

<script>
import { score, recipeDetail } from '@/api/searchFoods'
import DayRecipe from './day-recipe.vue'
export default {
  name: 'RecipeDetail',
  props: {
    id: {
      type: String,
      required: true
    },
    active: {
      type: Number
    },
    tenantId: {
      type: String
    },
    currentWeek: {
      type: String
    }
  },
  components: {
    DayRecipe
  },
  data() {
    return {
      recipeId: '', // 食谱id
      score: 0, // 食谱得分
      proList: [],
      propObj: {
        102: '蛋白质',
        103: '脂肪',
        104: '碳水化合物'
      },
      currentRecipe: null, // 当前食谱
      loading: true
    }
  },
  mounted() {
    this.recipeId = this.id
    this.init(this.id)
  },
  methods: {
		toNutrition(){
			this.$router.push(`/nutrition?id=${this.id}&tenantId=${this.tenantId}`)
		},
    update(val) {
      this.$emit('up-week', val)
    },
    async init(id) {
      await this.getScore(id)
      await this.getDetail(id)
    },
    // 根据食谱id获取食谱评分
    async getScore(id) {
      try {
        const { data } = await score(id, this.tenantId)
        const arr = []
        this.score = Math.round(data.data.totalValue * 1)
        this.energyList = data.data.proteinrSourceDTOList
        let arr2 = data.data.proteinrSourceDTOList
        let powerTarget = parseFloat(data.data.recipeCalDTOList[0].powerTarget)
        arr2.forEach((ele, index) => {
          let u2Value = parseFloat(ele.u2)
          let u3Value = parseFloat(ele.u3)
          let percentNum = index == 1 ? 9 : 4
          let target = ((powerTarget / percentNum) * (u2Value + u3Value)) / 2
          let nowPercent = ((ele.value / target) * 100).toFixed(1)
          let num = ele.real
          if (num < ele.u1) {
            ele.text = '不足'
          } else if (num > ele.u4) {
            ele.text = '过量'
          } else {
            ele.text = '适量'
          }
          if (powerTarget == 0 && arr2.value > 0) {
            arr.push({
              id: 'data' + index,
              name: this.propObj[arr2[index].nutrientId],
              message: nowPercent * 1,
              result: nowPercent * 1 + '%',
              text: ele.text
            })
          } else {
            arr.push({
              id: 'data' + index,
              name: this.propObj[arr2[index].nutrientId],
              message: nowPercent,
              result: nowPercent * 1 + '%',
              text: ele.text
            })
          }
        })
        this.proList = arr
      } catch (error) {
        console.log(error)
      }
    },
    // 根据食谱id获取食谱详情
    async getDetail(id) {
      try {
        this.loading = true
        const { data } = await recipeDetail(id)
        this.currentRecipe = data.data
        this.loading = false
      } catch (error) {
        console.log(error)
      }
    },
    // 帮助popup
    handleShowHelp() {
      this.showHelp = true
    }
  }
}
</script>

<style lang="less" scope>
.recipe-detail {
  box-sizing: border-box;
	.week-rate-item{
		.title{
			display: flex;
			align-items: center;
			justify-content: space-between;
			.more{
				position: relative;
				font-size: 0.26rem;
				color: #666;
			}
			.more::after{
				position: absolute;
				right: -0.28rem;
				top: -0.03rem;
				content: '>';
				width: 0.24rem;
				height: 0.24rem;
				color: #666;
			}
		}
	}
}
.loading {
  height: calc(100vh - 3.6rem);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
